<svg [attr.width]="width" [attr.height]="height"><use [attr.href]="'assets/images/sprite.svg#' + id"></use></svg>
